import { render, staticRenderFns } from "./OsSurveyTutorial.vue?vue&type=template&id=6d571ab6&scoped=true"
import script from "./OsSurveyTutorial.vue?vue&type=script&lang=ts"
export * from "./OsSurveyTutorial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d571ab6",
  null
  
)

export default component.exports